var _defs, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCards({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#767493;}.cls-2{fill:none;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.84,16.97c-.71-.71-1.72-.71-1.72-.71H15.88c-1.01,0-1.72.71-1.72.71-.71.71-.71,1.72-.71,1.72v11.37c0,1.01.71,1.72.71,1.72.71.71,1.72.71,1.72.71h16.24c1.01,0,1.72-.71,1.72-.71.71-.71.71-1.72.71-1.72v-11.37c0-1.01-.71-1.72-.71-1.72Zm-18.78,4.16h17.87v1.62h-4.95c-.58,0-1.03.37-1.03.37-.45.37-.56.94-.56.94-.18.83-.85,1.38-.85,1.38-.67.55-1.54.55-1.54.55-.87,0-1.54-.55-1.54-.55-.67-.55-.85-1.39-.85-1.39-.11-.56-.56-.93-.56-.93-.45-.37-1.03-.37-1.03-.37h-4.95v-1.62Zm.24-3.01c.24-.24.57-.24.57-.24h16.24c.34,0,.57.24.57.24.24.24.24.57.24.57v.81H15.07v-.81c0-.34.24-.57.24-.57Zm17.39,12.52c-.24.24-.57.24-.57.24H15.88c-.34,0-.57-.24-.57-.24-.24-.24-.24-.57-.24-.57v-5.68h4.95s0,0,0,0c.3,1.41,1.42,2.32,1.42,2.32,1.12.91,2.56.91,2.56.91,1.44,0,2.56-.91,2.56-.91,1.12-.9,1.42-2.32,1.42-2.32h4.95v5.68c0,.34-.24.57-.24.57Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15581"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_202",
    className: "cls-2",
    width: 48,
    height: 48
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCards);
export default __webpack_public_path__ + "static/media/icon_cards.8e911e5c5a5bf9e4d9775ee4b40aaceb.svg";
export { ForwardRef as ReactComponent };